import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/es/industrias/pharma-biotech/biotech-emergente")({
  head: () => buildRouteHead("/es/industrias/pharma-biotech/biotech-emergente"),
  component: SolutionDetail,
});

